import DataFetcherTemplate from "../hooks/fetchTemplate";
import BlockRightImage from "../components/BlockRightImage";
import BlockImageCabecera from "../components/BlockImageCabecera";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import FixedHeader from "../components/FixedHeader";

function RelacionesInterinstitucionales() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <FixedHeader
              src={item.field_portada}
              video={item.field_video_portada}
              span0="Conectamos"
              span1="a la UTPL"
              span2="con el mundo 🌎"
            ></FixedHeader>
                <Breadcumbs
                content={
                  <>
                    <NavLink to="/relaciones-interinstitucionales">
                      Relaciones Interinstitucionales
                    </NavLink>
                  </>
                }
              ></Breadcumbs>

      

            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <div className="lightbluebg ">
            
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque1,
                }}
              />
            </div>
            <div className="padding bluebg">
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque2,
                }}
              />
            </div>
            <div className="padding">
              <BlockRightImage
                src={item.field_imagen3}
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      {" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/relaciones-interinstitucionales.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
    </>
  );
}

export default RelacionesInterinstitucionales;
